import { render } from "./expand-list.vue?vue&type=template&id=1b6f23cb&lang=pug"
import script from "./expand-list.vue?vue&type=script&lang=js"
export * from "./expand-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__